import Style, { StyleFunction } from 'ol/style/Style'

import { mapAtom } from 'apps/route-manager/src/map/atoms/map/map'
import { Stroke } from 'ol/style'
import tinycolor from 'tinycolor2'
import { directionManager } from './managers'
import { drawDirectionIcon } from './renderer'
import { MAX_PATH_ZOOM_FOR_BREADCRUMBS } from '../../constants'

const whiteBackgroundStyleCache: Map<string, Style> = new Map()
const backgroundStyleCache: Map<string, Style> = new Map()
const foregroundStyleCache: Map<string, Style> = new Map()

/**
 * Main style object for route polylines
 */
export const pathStyle: StyleFunction = feature => {
  const zoom = mapAtom.map.getView().getZoom() || 0
  const mode = feature.get('mode')
  const type = feature.get('type')

  if (mode === 'off') return []
  if (type === 'breadcrumbPath' && zoom > MAX_PATH_ZOOM_FOR_BREADCRUMBS) return []

  const color = feature.get('color')
  const zIndex = type === 'routePolyline' ? 1 : 10

  const whiteBackgroundCacheKey = `${color}_${zIndex}`
  if (!whiteBackgroundStyleCache.has(whiteBackgroundCacheKey)) {
    whiteBackgroundStyleCache.set(
      whiteBackgroundCacheKey,
      new Style({
        stroke: new Stroke({ color: '#ffffff', width: 6 }),
        zIndex,
      }),
    )
  }

  const whiteBackgroundStroke = whiteBackgroundStyleCache.get(whiteBackgroundCacheKey)!

  const backgroundColor =
    type === 'routePolyline' ? tinycolor(color).setAlpha(0.3).toHex8String() : color

  const backgroundStyleCacheKey = `${backgroundColor}_${zIndex}`

  if (!backgroundStyleCache.has(backgroundStyleCacheKey)) {
    backgroundStyleCache.set(
      backgroundStyleCacheKey,
      new Style({
        stroke: new Stroke({ color: backgroundColor, width: 4 }),
        zIndex,
      }),
    )
  }

  const backgroundStroke = backgroundStyleCache.get(backgroundStyleCacheKey)!

  if (type !== 'routePolyline') {
    return [whiteBackgroundStroke, backgroundStroke] as Style[]
  }

  const foregroundStyleCacheKey = `${color}_${zIndex}`

  if (!foregroundStyleCache.has(foregroundStyleCacheKey)) {
    foregroundStyleCache.set(
      foregroundStyleCacheKey,
      new Style({
        stroke: new Stroke({ color: color, width: 4, lineDash: [5, 6], lineCap: 'butt' }),
        zIndex,
      }),
    )
  }

  const foregroundStroke = foregroundStyleCache.get(foregroundStyleCacheKey)

  return [whiteBackgroundStroke, backgroundStroke, foregroundStroke].filter(Boolean) as Style[]
}

/**
 * Draws all collected direction icons in a single batch
 * This should be called during the postrender event after collecting icons
 */
export function drawAllDirectionIcons(ctx: CanvasRenderingContext2D, pixelRatio: number): void {
  const icons = directionManager.getAll()
  for (const icon of icons) {
    drawDirectionIcon(ctx, icon, pixelRatio)
  }
}
